import { createApp } from 'vue'
import FormInputDropdown from './FormInputDropdown'

const el = '.kb-component--form-input-dropdown'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((FormInputDropdownDOM) => {
            const props = {
                tooltipText: FormInputDropdownDOM.dataset.tooltiptext,
                errorMessageLabel:
                    FormInputDropdownDOM.dataset.errormessagelabel,
                helpMessageLabel: 
                    FormInputDropdownDOM.dataset.helpmessagelabel,
                placeholder: FormInputDropdownDOM.dataset.placeholder,
                label: FormInputDropdownDOM.dataset.label,
                legend: FormInputDropdownDOM.dataset.legend,
                isRequired: !!(
                    FormInputDropdownDOM.dataset.isrequired === 'true'
                ),
                fieldName: FormInputDropdownDOM.dataset.fieldname,
                selectOptions: JSON.parse(
                    FormInputDropdownDOM.dataset.selectoptions
                )
            }
            const component = createApp(FormInputDropdown, props).use(Store)
            component.mount(FormInputDropdownDOM)
        })
    }
}
